import { defaultHttpClient } from 'shared/src/api/httpClient';

export type PutLikedFolderParams = {
  sno: number;
  title: string;
  image?: string | null;
};

export const putLikedFolder = async ({
  sno,
  title,
  image,
}: PutLikedFolderParams) => {
  return defaultHttpClient.request<void>({
    method: 'PUT',
    url: `/api/v2/members/me/liked_folders/${sno}/`,
    data: { title, image },
  });
};
